import BaseRequest from './BaseRequest';
import HTTPRequest from '../HTTPRequest';

export default class Providers extends BaseRequest {
    /**
     * Providers constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('Providers');
        this.setEndpoint('providers');
    }

    /**
     * @param {string} email
     * @param {string} password
     * @param {string} firstName
     * @param {string} lastName
     * @param {array} fieldValues
     * @param {string} referralCode
     * @param {integer} venue
     * @param {string} verificationKey
     * @return {object}
     */
    async registerCustomer(
        email = '',
        password = '',
        firstName = '',
        lastName = '',
        fieldValues = [],
        referralCode = '',
        venue = null,
        verificationKey = '',
    ) {
        let parameters = {
            email: email,
            fieldValues: fieldValues,
            firstName: firstName,
            lastName: lastName,
            password: password,
        };

        if (referralCode !== '') {
            parameters['referralCode'] = referralCode;
        }
        if (venue !== null) {
            parameters['venue'] = venue;
        }
        if (verificationKey !== '') {
            parameters['verificationKey'] = verificationKey;
        }

        const request = this.buildForwardRequest(
            this.getClassName(),
            'registerCustomer',
            parameters,
        );
        return await request.sendRequest();
    }

    /**
     * @return {object}
     */
    async customerReferralSettings() {
        const request = new HTTPRequest(
            'GET',
            `${this.getEndpoint()}/${this.getProviderId()}/customer_referral_settings?expand=signup_free_membership`,
            this.getHeaders(),
        );

        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'customerReferralSettings',
            );
        }

        return await request.sendRequest();
    }
}
